import React, { FC } from 'react';
import classNames from 'classnames';
import { Button } from '@src/components/Button';
import { useAppDispatch } from '@src/redux';
import { openActivateSubscriptionModal } from '@src/redux/actions/subscription';
import { SubscribeNoticeProps } from './props';
import './styles.scss';

export const SubscribeNotice: FC<SubscribeNoticeProps> = ({ className }) => {
  const dispatch = useAppDispatch();

  return (
    <div className={classNames('subscribe-notice', className)}>
      <h3 className="subscribe-notice__title">Upgrade for full access</h3>

      <p className="subscribe-notice__sub-title">
        You’re currently using MeetFrank for free. Activate your subscription and get full access to all talent on the
        MeetFrank platform and more.
      </p>

      <Button onClick={() => dispatch(openActivateSubscriptionModal())}>Upgrade</Button>
    </div>
  );
};
